module.exports = __webpack_public_path__ + "static/passnip-logo-e2a2a6e12fb2a8dc12318dd7ace91c43.svg";